<template>
  <div>
    <div id="ng-messagecenter-threads">
      <div
        class="messagecenter-threads"
        v-if="threads.length > 0">
        <ul>
          <li
            v-for="item in threads"
            :key="item.order">
            <a
              :href="
                'messagecenter.html?action=viewmessages&data=' +
                item.id +
                '&_csrf_token=' +
                csrfToken
              ">
              <div class="icon">
                <span>
                  <svgicon
                    aria-hidden="true"
                    original
                    :data="require('@iconPath/' + item.image + '.svg?inline')"
                    width="32"
                    height="32"></svgicon>
                </span>
              </div>
              <div class="title">
                <p :class="{ read: item.threadread }">{{ item.title }}</p>
              </div>
              <div class="date">
                <p :class="{ read: item.threadread }">{{ item.dateortime }}</p>
              </div>
              <div class="text">
                <p>{{ item.text }}</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <div
        class="messagecenter-threads-empty"
        v-if="threads.length <= 0">
        <div class="title"><p>Your message center is empty.</p></div>
        <div class="text">
          <p>Once there is a message thread, you'll see it listed here.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ThreadsComponent',
  props: {
    threadHouseholdId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      householdID: this.threadHouseholdId,
      threads: [],
      timerThreads: '',
      csrfToken: App.settings.CSRFToken
    }
  },
  created() {
    this.fetchThreads()
    this.timerThreads = setInterval(this.fetchThreads, 60000)
  },
  methods: {
    fetchThreads() {
      if (this.householdID === 0) {
        return
      }

      axios
        .get('api/messagecenter/threads/' + this.householdID)
        .then((data) => {
          this.threads = Array.isArray(data.data.threads)
            ? data.data.threads
            : []
        })
    }
  },
  beforeUnmount() {
    clearInterval(this.timerThreads)
  }
}
</script>

<style lang="less">
@import '../assets/css/abstract/variables.less';
@import '../assets/css/abstract/mixins.less';

#ng-messagecenter-threads {
  width: 100%;
  min-height: 600px;
  margin-top: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 20%);
  border: solid 1px rgba(192, 192, 192, 0.5);
  float: left;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
    z-index: 1;

    li {
      list-style: none;
      padding: 0;
      margin: 2px;
      width: 100%;
      height: 88px;
      border-bottom: solid 1px rgba(192, 192, 192, 0.5);

      a {
        .default-focus-indicator(0, @primary-color);
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        color: @text-color;
        background-color: #fff;
        position: relative;
        overflow: visible;
        flex-direction: row;
        align-items: center;
        display: block;

        &:focus,
        &:hover {
          background-color: @gray-hover-color !important;
        }

        .icon {
          position: absolute;
          top: 13px;
          left: 15px;
          width: 62px;
          height: 62px;
          background-color: #fff;
          border-radius: 31px;
          border: solid 1px rgba(192, 192, 192, 0.5);

          .svg-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -16px;
            margin-left: -16px;

            & * {
              fill: @text-color;
            }
          }
        }

        .title {
          font-size: @font-size-12px;
          margin-top: 16px;
          margin-left: 90px;
          font-weight: 600;
          overflow: hidden;
          height: 20px;
          width: 232px;
          float: left;

          p {
            font-weight: 600;
            padding: 0;

            &.read {
              font-weight: 400;
            }
          }
        }

        .date {
          font-size: @font-size-12px;
          margin-top: 16px;
          padding-right: 16px;
          overflow: hidden;
          height: 20px;
          width: 88px;
          float: right;

          p {
            font-weight: 600;
            padding: 0;
            text-align: right;

            &.read {
              font-weight: 400;
            }
          }
        }

        .text {
          font-size: @font-size-12px;
          color: #77797a;
          margin-top: 3px;
          margin-left: 90px;
          overflow: hidden;
          height: 40px;
          width: 80%;
          float: left;

          p {
            font-weight: 400;
            padding: 0;
          }
        }

        &:hover,
        &:focus,
        &:active,
        &:active:hover,
        &:active:focus,
        &.selected {
          background-color: #fff; //@color-off-white
        }
      }
    }
  }

  .messagecenter-threads-empty {
    width: 100%;
    height: 100%;

    .title {
      color: @primary-color;
      font-size: @font-size-16px;
      font-weight: 600;
      width: 100%;

      p {
        text-align: center;
      }
    }

    .text {
      font-size: @font-size-14px;
      width: 100%;
      text-align: center;

      p {
        text-align: center;
      }
    }
  }
}
</style>
